var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4571 10.6192C10.0264 10.5924 8.46605 11.4535 7.45876 12.8512C6.59356 14.0521 5.37617 16.7043 6.94583 20.9838C7.48344 22.4473 8.19001 23.8471 8.87394 25.2005C9.15927 25.7649 9.44452 26.3283 9.71544 26.8938L10.2984 28.1091L15.5935 23.7369L11.4571 10.6192Z",
    fill: "#E0F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0109 15.6578C28.9316 15.5229 28.8688 15.4209 28.8358 15.3509L24.0279 23.0705L28.363 28.3244L29.6865 25.8412C32.2171 21.0982 29.8039 17.003 29.0109 15.6578Z",
    fill: "#BBDCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1188 32.7656V36H23.9548C22.2251 36 20.7064 35.1773 19.736 33.8906C18.7656 35.1773 17.247 36 15.5173 36H12.3532V32.7656C12.3532 29.8547 14.7157 27.4922 17.6266 27.4922H21.8454C24.7563 27.4922 27.1188 29.8547 27.1188 32.7656Z",
    fill: "#E0F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2282 13.7812C29.2282 18.464 22.3305 28.7156 19.736 32.5125C17.1836 28.7788 10.2438 18.4851 10.2438 13.7812C10.2438 11.0391 11.0454 8.71868 12.1633 6.82031L16.0024 5.97656H24.672L27.3296 6.84134C28.4266 8.73984 29.2282 11.0601 29.2282 13.7812Z",
    fill: "#BBDCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1188 32.7656V36H23.9548C22.2251 36 20.7064 35.1773 19.736 33.8906V27.4922H21.8454C24.7563 27.4922 27.1188 29.8547 27.1188 32.7656Z",
    fill: "#BBDCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2282 13.7812C29.2282 18.464 22.3305 28.7156 19.736 32.5125V5.97656H24.672L27.3297 6.84134C28.4266 8.73984 29.2282 11.0601 29.2282 13.7812Z",
    fill: "#9ABADB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0219 4.98509C23.5117 1.86328 20.4321 0.3375 20.2 0.232031L19.736 0L19.272 0.232031C19.0399 0.3375 15.9392 1.88437 13.4502 5.00618C12.986 5.55462 12.5641 6.16641 12.1634 6.82031C12.3533 7.11555 12.5852 7.38977 12.8384 7.6429C14.6102 9.54141 17.1415 10.6172 19.736 10.6172C22.3306 10.6172 24.7563 9.58359 26.5704 7.72734C26.8446 7.45312 27.0977 7.15774 27.3298 6.84134C26.9079 6.16641 26.486 5.55462 26.0219 4.98509Z",
    fill: "#E0F4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3297 6.84134C27.0977 7.15781 26.8446 7.45312 26.5703 7.72734C24.7563 9.58359 22.3305 10.6172 19.736 10.6172V0L20.1999 0.232031C20.432 0.3375 23.5117 1.86328 26.0218 4.98509C26.486 5.55462 26.9079 6.16641 27.3297 6.84134Z",
    fill: "#BBDCFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7907 4.28906H18.6813V6.39844H20.7907V4.28906Z",
    fill: "#8C4A37"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.118 17.9998L17.6266 16.5084L16.1352 17.9998L17.6266 19.4912L19.118 17.9998Z",
    fill: "#E0F4FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7356 12.2827L18.238 13.7803L19.7356 15.2779L21.2332 13.7803L19.7356 12.2827Z",
    fill: "#E0F4FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3367 17.9998L21.8453 16.5084L20.3539 17.9998L21.8453 19.4911L23.3367 17.9998Z",
    fill: "#BBDCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.446 13.781L23.9546 12.2896L22.4633 13.781L23.9546 15.2724L25.446 13.781Z",
    fill: "#BBDCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 13.7811L15.5172 12.2897L14.0258 13.7811L15.5172 15.2725L17.0086 13.7811Z",
    fill: "#E0F4FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7358 20.7199L18.2382 22.2175L19.7358 23.7151L21.2334 22.2175L19.7358 20.7199Z",
    fill: "#E0F4FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7907 4.28906H19.736V6.39844H20.7907V4.28906Z",
    fill: "#663325"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2337 22.2187L19.736 23.7163V20.721L21.2337 22.2187Z",
    fill: "#BBDCFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2337 13.7812L19.736 15.2788V12.2835L21.2337 13.7812Z",
    fill: "#BBDCFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.f7628a6ac20e1adbd6ad4fa8d4f9e429.svg";
export { ForwardRef as ReactComponent };